const DELETED_MODEL_KEYWORD = 'BASETEN_DELETED_MODEL';

export { DELETED_MODEL_KEYWORD };
